import request from '@/utils/request'
import { getPublicKey } from '@/utils/auth'
import JSEncrypt from 'jsencrypt'
import { getAesKey, getIv, encryptedPwd } from '@/utils/encrypt'

// 获取短信验证码
export function smsCode(data) {
  return request({
    url: '/znbj/gateway',
    method: 'post',
    data: { apiCode: 'BA002', ...data }
  })
}

// 获取公钥
export function getPublic() {
  return request({
    url: '/znbj/gateway',
    method: 'post',
    data: { apiCode: 'BA024' }
  })
}

// 埋点接口(加密)多接口的情况可做二次封装
export async function clickAdTrigger(data) {
  console.log('======clickAdTrigger==========', data, getPublicKey())
  let aesKey = await getAesKey()
  let iv = await getIv()
  console.log('======clickAdTrigger aesKey iv======', aesKey, iv)
  let newData = await encryptedPwd(aesKey, iv, JSON.stringify(data))
  const rsaEncrypt = new JSEncrypt()
  rsaEncrypt.setPublicKey(getPublicKey())
  let aes_key = rsaEncrypt.encrypt(aesKey) // RSA加密AES密钥
  let aes_iv = rsaEncrypt.encrypt(iv)
  console.log('======clickAdTrigger111 aesKey iv======', aes_key, aes_iv)
  return request({
    url: '/znbj/gateway',
    method: 'post',
    data: { apiCode: 'BA022', aesKeyHex: aes_key, ivHex: aes_iv, appMetricGather: newData }
  })
}

// 广告
export function getAdList(data) {
  return request({
    url: '/znbj/gateway',
    method: 'post',
    data: { apiCode: 'BA006', ...data }
  })
}
// 广告点击
export function updateAdClick(data) {
  return request({
    url: '/znbj/gateway',
    method: 'post',
    data: { apiCode: 'BA007', ...data }
  })
}
// 文件上传
export function uploadBase64(data) {
  return request({
    url: '/znbj/file/base64',
    method: 'post',
    data: { apiCode: 'BA004', ...data },
    loading: true
  })
}

// 实名次数校验
export function countValid() {
  return request({
    url: '/znbj/gateway',
    method: 'post',
    data: { apiCode: 'BA009' }
  })
}

// ocr识别
export function ocrSubmit(data) {
  return request({
    url: '/znbj/gateway',
    method: 'post',
    data: { apiCode: 'UC004', ...data },
    loading: true
  })
}
export function submitPvUv(data) {
  return request({
    url: '/znbj/gateway',
    method: 'post',
    data: { apiCode: 'BA012', ...data }
  })
}
// 内容埋点
export function submitContentTrack(data, loading = false) {
  return request({
    url: '/znbj/gateway',
    method: 'post',
    data: { apiCode: 'SF017', ...data },
    loading
  })
}
// 搜索
export function keywordsSearch(data) {
  return request({
    url: '/znbj/gateway',
    method: 'post',
    data: { apiCode: 'MS007', ...data }
  })
}
// 获取配置参数
export function getConfing(data) {
  return request({
    url: '/znbj/gateway',
    method: 'post',
    data: { apiCode: 'BA019', ...data }
  })
}
// 获取菜单
export function getMenuList(data) {
  console.log(data,'22222---')
  return request({
    url: '/znbj/gateway',
    method: 'post',
    data: { apiCode: 'BA015',...data }
  })
}
// 获取字典数据
export function getDictData(data) {
  return request({
    url: '/znbj/gateway',
    method: 'post',
    data: { apiCode: 'BA021', ...data }
  })
}
export function getOutApiUrl(data) {
  return request({
    url: '/znbj/gateway',
    method: 'post',
    data: { apiCode: 'VI153', ...data }
  })
}
// 渠道会员行权地址
export function getMemberApiUrl(data, loading = false) {
  return request({
    url: '/znbj/gateway',
    method: 'post',
    data: { apiCode: 'UC107', ...data },
    loading
  })
}
// 根据专区类型获取活动专区页
export function getActivityPage(data) {
  return request({
    url: '/znbj/gateway',
    method: 'post',
    data: { apiCode: 'MM010', ...data },
    loading: true
  })
}

// 获取ocr完成之后的照片信息
export function getOcrImgInfo(data, loading = false) {
  return request({
    url: '/znbj/gateway',
    method: 'post',
    data: { apiCode: 'UC012', ...data },
    loading
  })
}
